import React from "react";

const parseServices = value => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const toMinutes = value => {
  const text = String(value || "").trim();
  const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(text);
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
};

const inferDuration = entry => {
  const fromDb = Number(entry.totalDuration || 0);
  if (fromDb > 0) return fromDb;

  const startMins = toMinutes(entry.start);
  const endMins = toMinutes(entry.end);
  if (startMins == null || endMins == null) return 30;

  const sameDayDuration = endMins - startMins;
  if (sameDayDuration > 0) return sameDayDuration;

  return (endMins + 1440) - startMins;
};

const WorkBlock = ({ entry, memberColor, overlapIndex = 0, overlapCount = 1, slotMinutes = 15, onClick }) => {
  const services = parseServices(entry.servicesJson);
  const serviceLabel = services.length
    ? services.map(service => service.name).join(", ")
    : (entry.service || "-");
  const customerName = entry.isWalkIn ? "Walk-in" : (entry.customer || "Customer");
  const isInvoiceDone = !!entry.convertedToSaleRef;
  const hasCarryForwardService = services.some(service => String(service?.status || "").toLowerCase() === "carry_forward");
  const isFollowUpAppointment = !!String(entry.followUpSourceRef || "").trim();
  const isFollowUpClosed = isFollowUpAppointment && Number(entry.closedWithoutInvoice || 0) === 1;
  const durationMinutes = inferDuration(entry);
  const slotHeightPx = 56;
  const blockHeight = Math.max(58, Math.round((durationMinutes / slotMinutes) * slotHeightPx) - 10);
  const widthPercent = overlapCount > 1 ? (100 / overlapCount) : 100;
  const leftPercent = overlapIndex * widthPercent;

  return (
    <div
      className={`work-block ${overlapCount > 1 ? "overlap" : ""}`.trim()}
      style={{
        height: `${blockHeight}px`,
        background: memberColor || "#bfa58a",
        left: `calc(${leftPercent}% + 5px)`,
        width: `calc(${widthPercent}% - 10px)`
      }}
      onClick={event => {
        event.stopPropagation();
        if (onClick) onClick();
      }}
      role="button"
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          if (onClick) onClick();
        }
      }}
    >
      <strong>{customerName}</strong>
      <div>{serviceLabel}</div>
      {isInvoiceDone && <div className="work-block-status">Invoice Done</div>}
      {hasCarryForwardService && <div className="work-block-status work-block-status-carry-forward">Carry Forward Found</div>}
      {isFollowUpAppointment && <div className="work-block-status work-block-status-follow-up">Online Booking</div>}
      {isFollowUpClosed && <div className="work-block-status work-block-status-follow-up-closed">Online Booking Closed</div>}
      <div>{entry.start} - {entry.end} ({durationMinutes}m)</div>
    </div>
  );
};

export default WorkBlock;
